document.addEventListener('change', function (e) {
  var screenWidth = window.innerWidth;

  if (screenWidth > 990) {
    return;
  }

  var mainSwatch = e.target.closest('.nk-product__shell .nk-product__swatch-input');

  if (!mainSwatch) {
    return;
  }

  var stickyBar = e.target.closest('.nk-sticky-atc');
  if (stickyBar) {
    return;
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });

});